import { gql } from '@apollo/client';

import { PAS_FIND_FRAGMENT } from './getSitePasFindsQuery';

export const MARK_AMCR_FIND_SUBMITTED_MUTATION = gql`
  mutation MarkAmcrFindSubmittedMutation($findId: ID!) {
    markAmcrFindSubmitted(findId: $findId) {
      ... on UpdateFindSuccess {
        find {
          ...PasFindFields
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${PAS_FIND_FRAGMENT}
`;
